import { Decimal } from 'decimal.js';
import { formatCurrency } from 'src/helpers/currency';

export const currencyCellFormatter = (amount: number | string | Decimal): string => {
  if (amount === '' || amount === undefined || amount === null) {
    return '';
  }
  return formatCurrency(amount);
};
